import { c as _c } from "react/compiler-runtime";
import { Badge, Popover, Skeleton, Status } from '@systemeio/components';
import { CurrencyEnum } from '@systemeio/types';
import { AffiliateCard, AffiliateCardTitle, AffiliateStatRow } from 'modules/affiliate/components/affiliate-card';
import { AffiliateStatisticBaseInterface, AffiliateSumType } from 'modules/affiliate/types/affiliate-statistic-interface';
import { getAffiliateSum } from 'modules/affiliate/utils/get-affiliate-sum';
import { getMainCurrency } from 'modules/affiliate/utils/get-main-currency';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
interface AffiliateEarningsCardProps {
  affiliateStatistic?: AffiliateStatisticBaseInterface;
  selectedCurrency?: CurrencyEnum;
}
export function AffiliateEarningsCard(t0) {
  const $ = _c(80);
  const {
    affiliateStatistic,
    selectedCurrency
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== affiliateStatistic || $[1] !== selectedCurrency) {
    t1 = selectedCurrency ?? (affiliateStatistic && getMainCurrency(affiliateStatistic.total));
    $[0] = affiliateStatistic;
    $[1] = selectedCurrency;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currency = t1;
  let t2;
  if ($[3] !== affiliateStatistic || $[4] !== selectedCurrency) {
    t2 = !selectedCurrency && !!affiliateStatistic && Object.keys(affiliateStatistic.total).length > 1;
    $[3] = affiliateStatistic;
    $[4] = selectedCurrency;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const reservesOtherCurrenciesSlot = t2;
  let t3;
  if ($[6] !== currency || $[7] !== reservesOtherCurrenciesSlot || $[8] !== selectedCurrency) {
    t3 = sums => sums ? <Amount sums={sums} currency={currency} showOtherCurrencies={!selectedCurrency} reservesOtherCurrenciesSlot={reservesOtherCurrenciesSlot} /> : <Skeleton className="h-5 w-16" />;
    $[6] = currency;
    $[7] = reservesOtherCurrenciesSlot;
    $[8] = selectedCurrency;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const renderAmount = t3;
  let t4;
  if ($[10] !== t) {
    t4 = t("dashboard.affiliate.earnings");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <AffiliateCardTitle>{t4}</AffiliateCardTitle>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("dashboard.affiliate.today");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = affiliateStatistic?.today;
  let t8;
  if ($[16] !== renderAmount || $[17] !== t7) {
    t8 = renderAmount(t7);
    $[16] = renderAmount;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <AffiliateStatRow label={t6}>{t8}</AffiliateStatRow>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("dashboard.affiliate.last_7_days");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = affiliateStatistic?.last7Days;
  let t12;
  if ($[24] !== renderAmount || $[25] !== t11) {
    t12 = renderAmount(t11);
    $[24] = renderAmount;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <AffiliateStatRow label={t10}>{t12}</AffiliateStatRow>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("dashboard.affiliate.last_30_days");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = affiliateStatistic?.last30Days.sums;
  let t16;
  if ($[32] !== renderAmount || $[33] !== t15) {
    t16 = renderAmount(t15);
    $[32] = renderAmount;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t14 || $[36] !== t16) {
    t17 = <AffiliateStatRow label={t14}>{t16}</AffiliateStatRow>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t13 || $[39] !== t17 || $[40] !== t9) {
    t18 = <dl className="flex flex-col gap-2">{t9}{t13}{t17}</dl>;
    $[38] = t13;
    $[39] = t17;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("dashboard.affiliate.paid");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t19) {
    t20 = <Status color="active">{t19}</Status>;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  const t21 = affiliateStatistic?.paidSums;
  let t22;
  if ($[46] !== renderAmount || $[47] !== t21) {
    t22 = renderAmount(t21);
    $[46] = renderAmount;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t20 || $[50] !== t22) {
    t23 = <AffiliateStatRow label={t20}>{t22}</AffiliateStatRow>;
    $[49] = t20;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t) {
    t24 = t("dashboard.affiliate.pending");
    $[52] = t;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t24) {
    t25 = <Status color="inactive">{t24}</Status>;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  const t26 = affiliateStatistic?.pendingSums;
  let t27;
  if ($[56] !== renderAmount || $[57] !== t26) {
    t27 = renderAmount(t26);
    $[56] = renderAmount;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t25 || $[60] !== t27) {
    t28 = <AffiliateStatRow label={t25}>{t27}</AffiliateStatRow>;
    $[59] = t25;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t23 || $[63] !== t28) {
    t29 = <dl className="border-border-200 flex flex-col gap-2 border-y py-4">{t23}{t28}</dl>;
    $[62] = t23;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== t) {
    t30 = t("dashboard.affiliate.lifetime_earnings");
    $[65] = t;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t30) {
    t31 = <dt>{t30}</dt>;
    $[67] = t30;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  const t32 = affiliateStatistic?.total;
  let t33;
  if ($[69] !== renderAmount || $[70] !== t32) {
    t33 = <dd className="text-3xl font-medium">{renderAmount(t32)}</dd>;
    $[69] = renderAmount;
    $[70] = t32;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t31 || $[73] !== t33) {
    t34 = <dl className="text-text-primary flex flex-wrap items-center justify-between gap-3 pt-2">{t31}{t33}</dl>;
    $[72] = t31;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t18 || $[76] !== t29 || $[77] !== t34 || $[78] !== t5) {
    t35 = <AffiliateCard>{t5}{t18}{t29}{t34}</AffiliateCard>;
    $[75] = t18;
    $[76] = t29;
    $[77] = t34;
    $[78] = t5;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  return t35;
}
interface AmountProps {
  sums: AffiliateSumType;
  currency: CurrencyEnum | undefined;
  showOtherCurrencies: boolean;
  reservesOtherCurrenciesSlot: boolean;
}
function Amount(t0) {
  const $ = _c(15);
  const {
    sums,
    currency,
    showOtherCurrencies,
    reservesOtherCurrenciesSlot
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== currency || $[1] !== showOtherCurrencies || $[2] !== sums) {
    t1 = showOtherCurrencies ? (Object.keys(sums) as CurrencyEnum[]).filter(cur => cur !== currency) : [];
    $[0] = currency;
    $[1] = showOtherCurrencies;
    $[2] = sums;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const otherCurrencies = t1;
  const t2 = user?.dashboardLocale;
  let t3;
  if ($[4] !== currency || $[5] !== sums || $[6] !== t2) {
    t3 = getAffiliateSum(sums, currency, t2);
    $[4] = currency;
    $[5] = sums;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== otherCurrencies || $[9] !== reservesOtherCurrenciesSlot || $[10] !== sums) {
    t4 = reservesOtherCurrenciesSlot && <span className="flex w-10 justify-end">{otherCurrencies.length > 0 && <OtherCurrencies sums={sums} currencies={otherCurrencies} />}</span>;
    $[8] = otherCurrencies;
    $[9] = reservesOtherCurrenciesSlot;
    $[10] = sums;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <span className="flex items-center justify-end gap-1.5">{t3}{t4}</span>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function OtherCurrencies(t0) {
  const $ = _c(23);
  const {
    sums,
    currencies
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Badge color="outlinedGray" size="lg" render={<button type="button" />} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `+${currencies.length}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <Popover.Trigger render={t1}>{t2}</Popover.Trigger>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Popover.Arrow />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t("dashboard.affiliate_dashboard.stats.other_currencies");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <Popover.Title className="border-border-200 text-text-primary border-b pb-2 text-sm font-medium">{t5}</Popover.Title>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currencies || $[9] !== sums || $[10] !== user?.dashboardLocale) {
    let t8;
    if ($[12] !== sums || $[13] !== user?.dashboardLocale) {
      t8 = cur => <div key={cur} className="flex items-center justify-between gap-1.5"><dt className="text-text-secondary">{cur.toUpperCase()}</dt><dd className="text-text-primary">{getAffiliateSum(sums, cur, user?.dashboardLocale)}</dd></div>;
      $[12] = sums;
      $[13] = user?.dashboardLocale;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t7 = currencies.map(t8);
    $[8] = currencies;
    $[9] = sums;
    $[10] = user?.dashboardLocale;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <dl className="flex flex-col gap-2">{t7}</dl>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <Popover.Portal><Popover.Positioner side="top" align="end"><Popover.Popup>{t4}<div className="flex flex-col gap-2 p-3 text-sm">{t6}{t8}</div></Popover.Popup></Popover.Positioner></Popover.Portal>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t9) {
    t10 = <Popover.Root>{t3}{t9}</Popover.Root>;
    $[20] = t3;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}